import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import { ActionsMenu } from '../ActionsMenu/ActionsMenu'
import { IImport } from '@user/store/import/typings'
import { entityTypeValueFormatter } from '../formatters/entityTypeFormatter'
import { Chip } from '@workwave-tidal/core/components'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import { GetStatusStyle } from './statusStyle'

export const importColumnDefinitions: GridColDef[] = [
  {
    field: 'actions',
    headerName: 'Actions',
    renderHeader: () => null,
    sortable: false,
    width: 40,

    renderCell({ row }) {
      return <ActionsMenu {...(row as IImport)} />
    },
    disableReorder: true,
    disableColumnMenu: true,
  },
  {
    field: 'createdDate',
    headerName: 'Import Date',
    width: 180,
    type: 'date',
  },
  {
    field: 'module',
    headerName: 'Module',
    sortable: false,
    width: 180,
    renderCell() {
      return <span>Sales Center</span>
    },
  },
  {
    field: 'entityType',
    headerName: 'Import Type',
    valueFormatter: entityTypeValueFormatter,
    width: 180,
  },
  {
    field: 'createdByName',
    headerName: 'Imported By',
    width: 180,
  },
  {
    field: 'name',
    headerName: 'Import Name',
    renderCell: ({ row, value }) => {
      if (['Completed', 'CompletedWithErrors'].includes(row.status)) {
        let url = '#'
        const searchParams = `?importIdFilter=${row.id}&importNameFilter=${value}`
        switch (row?.entityType) {
          case 'DraftLead':
            url = `/#/pending-leads${searchParams}`
            break
          case 'Lead':
            url = `/#/leads${searchParams}`
            break
          case 'Opportunity':
            url = `/#/opportunities${searchParams}`
            break
          default:
            break
        }
        return (
          <Link target="_blank" href={url}>
            {value}
          </Link>
        )
      }
      return <Box>{value}</Box>
    },
    width: 180,
  },
  {
    field: 'status',
    headerName: 'Import Status',
    width: 180,
    renderCell: ({ value }) => {
      const color =
        value === 'CompletedWithErrors'
          ? 'warning'
          : value === 'Failed'
          ? 'error'
          : value === 'Completed'
          ? 'success'
          : 'default'

      const style = GetStatusStyle(value)

      if (value === 'Processing' || value === 'NotStarted') {
        return (
          <Typography
            variant="body2"
            display="flex"
            alignItems="center"
            gap={(theme) => theme.spacing(0.5)}
          >
            {value === 'Processing' && (
              <CircularProgress color="primary" size={16} />
            )}

            {value?.replace(/([A-Z])/g, ' $1').trim() ?? ''}
          </Typography>
        )
      }
      return (
        <Chip
          size="small"
          variant="filledOutline"
          label={value?.replace(/([A-Z])/g, ' $1').trim() ?? ''}
          color={color}
          sx={style}
        />
      )
    },
  },
  {
    field: 'totalRecords',
    headerName: 'Total Records Imported',
    width: 200,
    type: 'number',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'description',
    headerName: 'Import Description',
    width: 400,
  },
]
